export enum DefaultStatesEnum {
  Draft = 0,
  Open = 2,
  Revise = 100,
  Approved = 101,
  Rejected = 102,
  Global = 103,
  Closed = 104,
}
